// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Dropdown from "@adl/XDL/Icons/Dropdown";
import { xBaseTheme } from "@adl/XDL/types";
import { color, styledScrollbar, xScreen } from "@adl/XDL/Utilities";
import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        iconProps: {
            ...DynamicDropdownPresentationPropsDefault?.iconProps,
            src: Dropdown,
            color: "common.ui7",
            css: css`
                justify-content: center;
                && svg {
                    width: 12px;
                    height: 12px;
                }
            `,
        },
        cssOverrides: {
            dropdownWrapper: css`
                & > ul {
                    margin-top: 0px;
                    box-shadow: none;
                    top: 36px;
                    width: 100%;
                    ${styledScrollbar(8)}
                    border: 1px solid ${color("common.ui2")};
                    border-top-left-radius: 0px;
                    border-top-right-radius: 0px;
                    border-bottom-left-radius: 2px;
                    border-bottom-right-radius: 2px;
                    ${xScreen("lte", "md")} {
                        max-height: 155px;
                    }
                }
                &[aria-expanded="true"] {
                    span[class^="IconWrapper"] {
                        transform: rotate(180deg);
                    }
                    input {
                        border-bottom-left-radius: 0px;
                        border-bottom-right-radius: 0px;
                    }
                }
            `,
            option: css`
                min-height: 46px;
                padding: 10px;
                line-height: 26px;
                color: ${color("text")};
                &[aria-selected="true"],
                &:hover {
                    background: ${color("common.ui4")};
                    color: ${color("text")};
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
